import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface Iuser {
  id: string;
  name: string;
  email: string;
  role: string;
  created_at?: string;
  // Campo opcional vindo do backend; se ausente, consideramos true no frontend
  isActive?: boolean;
}

const initialState: Iuser[] = []

const usersListSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
   
    setUsersList: (state, action: PayloadAction<Iuser[]>) => {
      return action.payload;
    },
  },
});

export const { setUsersList } = usersListSlice.actions;

export default usersListSlice.reducer;
